import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  NumberField,
  ShowButton,
  Show,
  SimpleShowLayout,
  ReferenceField,
  Filter,
  SearchInput,
  DateInput,
  SelectInput,
  TextInput,
} from 'react-admin';

const VideoWatchLogFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="title" alwaysOn />
    <TextInput source="userId" label="User ID" alwaysOn />
    <TextInput source="email" label="User Email" alwaysOn />
    <DateInput source="createdAt" label="Created After" />
    <SelectInput
      source="platform"
      choices={[
        { id: 'mobile', name: 'Mobile' },
        { id: 'web', name: 'Web' },
        { id: 'ios', name: 'iOS' },
        { id: 'android', name: 'Android' },
      ]}
    />
  </Filter>
);

export const VideoWatchLogList = props => (
  <List
    {...props}
    filters={<VideoWatchLogFilter />}
    sort={{ field: 'createdAt', order: 'DESC' }}
    bulkActionButtons={false}
  >
    <Datagrid>
      <TextField source="id" />
      <TextField source="userId" label="User ID" />
      <TextField source="user.email" label="User Email" />
      <TextField source="title" />
      <NumberField source="start" label="Start Time (s)" />
      <NumberField source="end" label="End Time (s)" />
      <TextField source="platform" />
      <ReferenceField source="courseSectionId" reference="skills/videos" label="Course Section">
        <TextField source="title" />
      </ReferenceField>
      <DateField source="createdAt" showTime />
      <ShowButton />
    </Datagrid>
  </List>
);

export const VideoWatchLogShow = props => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="userId" label="User ID" />
      <TextField source="user.email" label="User Email" />
      <TextField source="title" />
      <NumberField source="start" label="Start Time (seconds)" />
      <NumberField source="end" label="End Time (seconds)" />
      <TextField source="videoURL" label="Video URL" />
      <TextField source="platform" />
      <ReferenceField source="courseSectionId" reference="skills/videos" label="Course Section">
        <TextField source="title" />
      </ReferenceField>
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
    </SimpleShowLayout>
  </Show>
); 